import * as React from 'react';
import { registerComponent } from '@avensia/excite';
import { isSvenssons } from 'webapp/theme';
import BaseProductListingPage from 'webapp/pages/BaseProductListingPage';

export default registerComponent<NordicNest.Api.BrandPageApiModel>(props => (
  <BaseProductListingPage {...props} useRightTopImage={isSvenssons} />
));
